import { render, staticRenderFns } from "./diapositiva-5.vue?vue&type=template&id=33dc43eb&scoped=true&"
import script from "./diapositiva-5.vue?vue&type=script&lang=js&"
export * from "./diapositiva-5.vue?vue&type=script&lang=js&"
import style0 from "./diapositiva-5.vue?vue&type=style&index=0&id=33dc43eb&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "33dc43eb",
  null
  
)

export default component.exports